import React from 'react'
import './App.css'
import NASASkyExplorer from './components/NASASkyExplorer'

function App() {
  return (
    <div className="App full-screen">
      <NASASkyExplorer />
    </div>
  )
}

export default App